var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [[_c('ShopIconNavbar')], _c('b-nav-item-dropdown', {
    staticClass: "funko-dropdown-menu",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_vm.userLogin != null ? _c('em', {
          staticClass: "funko-label-name"
        }, [_vm._v(_vm._s(_vm.getLabelName))]) : _c('em', {
          staticClass: "funko-label-name"
        }, [_vm._v(" SIN SESIÓN ")])];
      },
      proxy: true
    }])
  }, [_vm.userLogin != null ? [_c('b-dropdown-item', {
    staticClass: "funko-label-logout",
    on: {
      "click": _vm.misCompras
    }
  }, [_c('span', [_vm._v("Mis Compras")]), _c('b-icon', {
    staticClass: "float-end funko-label-icon",
    attrs: {
      "icon": "cart-check-fill",
      "scale": "1",
      "variant": "black"
    }
  })], 1), _c('b-dropdown-item', {
    staticClass: "funko-label-logout",
    on: {
      "click": _vm.salir
    }
  }, [_c('span', [_vm._v("Salir")]), _c('b-icon', {
    staticClass: "float-end funko-label-icon",
    attrs: {
      "icon": "box-arrow-right",
      "scale": "1",
      "variant": "black"
    }
  })], 1)] : _c('b-dropdown-item', {
    staticClass: "funko-label-logout",
    on: {
      "click": _vm.ingresar
    }
  }, [_c('span', [_vm._v("Ingresar")]), _c('b-icon', {
    staticClass: "float-end funko-label-icon",
    attrs: {
      "icon": "box-arrow-in-left",
      "scale": "1",
      "variant": "black"
    }
  })], 1)], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }